import { IStore } from 'store/types';
import { IntegrationCategory, IntegrationType, ISiteIntegration } from 'types';

export const selectSite = () => (state: IStore) => state.site;

export const selectSiteSettings = () => (state: IStore) => state.site?.settings;

export const selectSitePOSIntegration =
  () =>
  (state: IStore): ISiteIntegration | undefined => {
    const categories = [IntegrationCategory.LABOR, IntegrationCategory.TICKET];
    return state.site?.integrations?.find((integration) => integration?.categories?.some((v) => categories.includes(v)));
  };

export const selectHasIntegration =
  (type: IntegrationType) =>
  (state: IStore): boolean =>
    !!state.site?.integrations?.some((integration) => integration.type === type);

export const selectSiteAccountBalance = () => (state: IStore) => state.site?.accountBalance;
